import { useAuth } from "@/context/AuthContext"
import { Navigate, useLocation } from "react-router-dom"
import { ReactNode, useEffect } from "react"

type Props = {
  children: ReactNode
  allowedRoles?: string[]
}

// Get default dashboard route based on role
function getDefaultRoute(role: string): string {
  const routes: Record<string, string> = {
    staff: "/frontdesk",
    doctor: "/",
    admin: "/settings"
  };
  return routes[role] || "/";
}

export default function ProtectedRoute({ children, allowedRoles }: Props) {
  const { currentUser, logout } = useAuth()
  const location = useLocation()

  // Not authenticated - redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />
  }

  // Check if role is allowed for this route
  if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
    // ✅ Logout user if accessing unauthorized route
    console.warn(`Unauthorized access attempt to ${location.pathname} by role: ${currentUser.role}`)
    logout()
    return null
  }

  return <>{children}</>
}